import { Drawer, Spin } from "antd";
import ComplementsComponent from "./ComplementsComponent";
import { useContext, useEffect, useMemo, useState } from "react";
import { getDistributionPointById, ResponseEntryDetail } from "api/generated";
import { useClient } from "hooks/useClient";
import DistributionPointSelected from "context/MyDistributionPoint";

interface ComplementsDrawerProps {
  complement?: ResponseEntryDetail;
  onReturn: (reload?: boolean) => void;
}

export default function ComplementsDrawer({
  onReturn,
  complement,
}: ComplementsDrawerProps) {
  const { client } = useClient();
  const { distributionPoint } = useContext(DistributionPointSelected);
  const [isLoading, setIsLoading] = useState(false);
  const [complementType, setcomplementType] = useState<string>();

  useEffect(() => {
    if (!distributionPoint) {
      return;
    }
    setIsLoading(true);
    getDistributionPointById({
      client,
      path: {
        id: distributionPoint.id,
      },
    })
      .then(({ data }) => {
        setcomplementType(data?.companyActivityType);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [client, distributionPoint?.id]);

  const complementToEdit = useMemo(() => {
    if (!complement) {
      return undefined;
    }
    return {
      currentCfdiComplement: complement.cfdiComplement,
      isCfdiComplement: complement.cfdiComplement?.id !== undefined,

      currentTransportComplement: complement.transportComplement,
      isTransportComplement: complement.transportComplement?.id !== undefined,

      currentStorageComplement: complement.storageComplement,
      isStorageComplement: complement.storageComplement?.id !== undefined,

      currentInternationalComplement: complement.internationalComplement,
      isInternationalComplement:
        complement.internationalComplement?.id !== undefined,

      isCurrentEditAllowed: complement.isEditAllowed,

      currentCFDIRegisterType: "RECEPCION",
      currentCFDIType: "EGRESO",

      inputRegisterUUID: complement.id,
      clarifications: complement.clarifications,
    };
  }, []);

  return (
    <div>
      <Drawer
        placement="bottom"
        onClose={() => {
          onReturn();
        }}
        open={complement !== undefined}
        styles={{
          mask: {
            backdropFilter: "blur(10px)",
          },
        }}
        width={"100%"}
        height={"100%"}
      >
        <Spin spinning={isLoading}>
          <ComplementsComponent
            transactionType="compra"
            complementType={complementType}
            currentComplementInfo={complementToEdit}
            handleReturnToTable={() => {
              onReturn(true);
            }}
          />
        </Spin>
      </Drawer>
    </div>
  );
}
